import { LogService } from 'app/services/logging.service';
import { AppModuleServices } from 'app/utils/app-module-util';

import { Keys } from './keys';

export default class Keyboard {
  private keysPressed: Record<string, boolean> = {};
  private logger: LogService;

  private static instance: Keyboard | undefined;

  private _disabled = false;
  public get disabled() {
    return this._disabled;
  }
  public set disabled(value) {
    this._disabled = value;
    if (value) {
      this.keysPressed = {};
    }
  }

  public constructor() {
    this.logger = AppModuleServices.injector.get<LogService>(LogService);
    Keyboard.instance = this;
  }

  public isKeyPressed(key: Keys): boolean {
    if (this.disabled) {
      return false;
    }
    return !!this.keysPressed[key];
  }

  public onKeyDown(e: KeyboardEvent): void {
    // Ignore if disabled.
    // Ignore modified keys because they don't emit keyUp events like unmodified keys.
    if (!this.disabled && !e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey) {
      this.keysPressed[e.code] = true;
    }
    if (e.code === Keys.KEY_L && e.shiftKey && e.ctrlKey) {
      this.logger.toggleConsole();
    }
  }

  public onKeyUp(e: KeyboardEvent): void {
    delete this.keysPressed[e.code];
  }

  public static getInstance(): Keyboard {
    if (!Keyboard.instance) {
      Keyboard.instance = new Keyboard();
    }
    return Keyboard.instance;
  }
}
